import React from 'react';
import cx from 'classnames';
// import Icon from 'components/Icon';
import s from './SortArrows.module.scss';
import { IconSortingArrowUp, IconSortingArrowDown} from "@/shared/ui/Icons";

type SortArrowsProps = {
  isSortedDesc?: boolean;
  className?: string;
}

const SortArrows: React.FC<SortArrowsProps> = ({ isSortedDesc, className = '' }) => {
  return (
    <button className={cx(s.root, className)}>
      { isSortedDesc === undefined ? <span><IconSortingArrowUp /></span> : isSortedDesc ? <span><IconSortingArrowUp /></span> : <span className={s.empty} /> }
      { isSortedDesc === undefined ? <span><IconSortingArrowDown /></span> : !isSortedDesc ? <span> <IconSortingArrowDown /></span> : <span className={s.empty} /> }
    </button>
  );
}

export default SortArrows;
